import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { PerformanceProfilePersonalReview } from './performance-profile-personal-review.model';

export class PerformanceProfilePersonalReviewStateModel extends EntityStateModel<PerformanceProfilePersonalReview> {}
